import React, { Component } from 'react';
const vis_node = '#8ae234';
const undis_node = '#EEEEEC';
const dis_node = '#fcaf3e';
const act_node = '#729fcf';
export default class DijTutIns extends Component {
    render() {
        return (
            <div className="left-div">
                <h3>Objective</h3>
                <p>
                    Given a directed graph with non-negative weights, find the
                    shortest path from the source node to every node in the
                    graph.
                </p>
                <h3>Color codes</h3>
                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: vis_node }}
                    ></div>
                    <p>Visited Node</p>
                </div>
                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: act_node }}
                    ></div>
                    <p>Active Node</p>
                </div>

                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: dis_node }}
                    ></div>
                    <p>Discovered Node</p>
                </div>
                <div className="color-code">
                    <div
                        className="color-bubble"
                        style={{ backgroundColor: undis_node }}
                    ></div>
                    <p>Undiscovered Node</p>
                </div>
                <h3>Setup</h3>
                <p>A node can be in one of the four states:</p>
                <p>
                    <u>Visisted Node</u>
                </p>
                <p>
                    Node whose shortest distance from source node is finalized
                </p>
                <p>
                    <u>Discovered</u>
                </p>
                <p>
                    Node which are unvisited neighbours of active and visited
                    nodes
                </p>
                <p>
                    <u>UnDiscovered</u>
                </p>
                <p>
                    <u>All other nodes</u>
                </p>
                <p>
                    The unvisited node with the shortest distance from the
                    source is picked as the active node. A priority queue is
                    maintained for this purpose. Distance of active node's
                    unvisited neighbour is calculated as follows:
                    distance[neighbour] = min(distance[neighbour] +
                    edge_weight[activeNode->neighbour])
                </p>
                <p>
                    distance[neighbour] = min(distance[neighbour] +
                    edge_weight[activeNode->neighbour])
                </p>
                <p>Following controls are available to the user:</p>
                <p>
                    <u>VisitMin</u>
                </p>
                <p>
                    Picks the new active node from the head of the priority
                    queue and add it's unvisited neighbour to the queue. This
                    happens only when the distance of all unvisited neighbours
                    of old active node are computed correctly.
                </p>
                <p>
                    <u>Select and Submit</u>
                </p>
                <p>
                    Click on any unvisited neighbour of active node, enter the
                    computed distance of that node using the above formula and
                    click on submit.
                </p>
                <h3>Procedure</h3>
                <p>
                    Step 1: Click on VisitMin button to make the node with the
                    shortest distance from source as the new active node given
                    that distance of the unvisited neighbour's of the old active
                    node(if any) are correctly updated.
                </p>
                <p>
                    Step 2: Select the unvisited neighbours of the active node
                    and update their distance by entering a non-negative integer
                    in the text box and clicking on submit button.
                </p>
                <p>Step 3: Repeat steps 1 and 2 until the queue is empty.</p>
            </div>
        );
    }
}
